<template>
    <div>
        <nav class="navbar navbar-expand-lg">
            <div class="container-fluid">
                <div class="collapse navbar-collapse p-3" id="navbarNav">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <router-link class="nav-link active" to="/sasp/solicitud">Solicitud</router-link>
                        </li>
                        <li class="nav-item">
                            <router-link class="nav-link active" to="/sasp/consulta">Consulta</router-link>
                        </li>
                    </ul>
                </div>
                <div class="float-right">
                    <div class="dropdown float-right mt-4 text-center">
                        <i class="far fa-user fa-2x" style="color: #1e536bad;"></i>
                        <p style="color: #b0b0b0; font-weight: 600;">{{ userName }}</p>
                        <div class="dropdown-content">
                            <router-link class="nav-link active" to="/sasp/login">
                                <i class="fas fa-sign-out-alt mr-1" style="color: #1e536bad;"></i>
                                Cerrar sesión
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
export default { 
    data() {
        return {
        userName: localStorage.getItem("userId"),
        };
    },
    methods:{
        async getRoutesAPI() {
            this.$store.state.token = localStorage.getItem("token");

            const payloadMenu = {
                metodo: "GETMENU",
                data: `idUser=${localStorage.getItem("profileId")}&User=-1`,
            };

            try {
                const prom = await this.$store.dispatch("metodoPost", payloadMenu);
                if (prom) {
                    /*const routes = this.$store.getters.getRespuestaREST;
                    Object.values(routes._children).forEach((item) => {
                        if (item.route == "") delete item.route;
                    });
                    this.navigation = [routes];
                    this.$store.state.sidebarApps = this.navigation[0]._children;

                    if (this.$store.state.sidebarApps.length == 0) {
                        this.logOut("No tienes aplicaciónes asignadas", true);
                    }*/

                    this.$store.state.Loading = false;
                    return;
                }
            } catch (error) {
                this.logOut("Tu token ha expirado", true);
            }
        },
        async logOut(message, condition) {
            this.$store.state.Loading = false;
            if(!condition){
                const res = await this.$swal.fire({
                title: message,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                allowOutsideClick: false,
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Cerrar',
                background: '#fff',
                backdrop: `
                    rgba(0,0,123,0.4)
                `
                }).then((result) => {
                if (result.isConfirmed) {
                    localStorage.removeItem("token");
                        this.$router.push("/sasp/login");
                }
                })
            }
            if(condition){
                const res = await this.$swal.fire({
                title: message,
                icon: 'warning',
                confirmButtonColor: '#3085d6',
                allowOutsideClick: false,
                confirmButtonText: 'Cerrar',
                background: '#fff',
                backdrop: `
                    rgba(0,0,123,0.4)
                `
                }).then((result) => {
                    if (result.isConfirmed) {
                    localStorage.removeItem("token");
                        this.$router.push("/sasp/login");
                    }
                })
            }
        }
    },
    mounted() {
        this.getRoutesAPI();
    }
}
</script>
<style scoped>
.dropdown {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  border-radius: 10px;
  background-color: #f9f9f9;
  min-width: 185px;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.137);
  padding: 12px 16px;
  /* Ajustar la propiedad left para que aparezca desde el lado izquierdo */
  left: -110px; /* Esto desplaza el contenido del dropdown 160px hacia la izquierda */
  z-index: 1;
  color: rgb(155, 155, 155);
  cursor: pointer;
}
.dropdown:hover .dropdown-content {
  display: block;
}
a{
   color: #1e536bad;
   font-weight: 600;
}
a:active {
    color: #1e536be5; /* Color del enlace cuando se hace clic */
}
.navbar{
    height: 80px;
    background-color: #f1f1f1 !important;
    box-shadow: 0px 0px 10px 0px rgba(141, 141, 141, 0.26); /* Ajusta los valores según desees */
}
li{
    height: 80px;
    padding-top: 20px;
    padding-left: 7px;
    padding-right: 7px;
}
li:hover{
    background: rgba(201, 200, 200, 0.192);
background: linear-gradient(90deg, rgba(241,241,241,1) 0%, rgba(230, 230, 230, 0.589) 50%, rgba(241,241,241,1) 100%);
}
</style>